module.exports = __webpack_public_path__ + "img/poster-master-6.26a23919.jpg";